<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>
                    <a href="#">站内信</a>
                </li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle">
                <span>站内信</span>
            </div>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('all')">全部</el-button>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('1')">已读</el-button>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('0')">未读</el-button>
            <!-- <el-button type="danger" class="top_button" style="letter-spacing: 2px;float:right;" @click="deletechoose()">批量删除</el-button>
            <el-button type="warning" class="top_button" style="letter-spacing: 2px;float:right;" name="all" id="all" @click="selectall()">全选</el-button> -->
            <ul class="forminfoxx">
                <li v-for="(item, index) in list">
                    <div class="xxcontent">
                        <!-- <template v-if="item.account != '*'">
                            <input type="checkbox" class="left c3186c8" style="margin-right:5px;margin-top:9px;" name="ids" id="ids" v-bind:value="item.id"/>
                        </template> -->
                        <a class="left c3186c8" @click="showContent(index, item.account)" style="cursor: pointer;">{{item.msgTitle}}</a>
                        <template v-if="item.account != '*'">
                            <a class="right ml20 c3186c8" style="cursor: pointer;" @click="delsystemmessage(item.id)">删除</a>
                        </template>
                        <span class="right f666">{{item.createTime}}</span>
                        <template v-if="index == 0 && item.account == '*'">
                            <span style="color:coral;margin-left: 10px;font-size:10px;">（系统消息）</span>
                        </template>
                    </div>
                    <div v-show="show === index ? true : false">
                        <label class="c3186c8" style="color: red;">{{item.msgContent}}</label>
                        <template v-if="item.account != '*' && item.state == 0">
                            <a class="right ml20 c3186c8" style="cursor: pointer;" @click="updatesystemmessage(item.id)">标记为已读</a>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
        <div class="pagin" style="float:right;margin-bottom:15px;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[pageSize]"
                :page-size="50"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div>
        <!-- <el-button type="warning" class="top_button" style="letter-spacing: 2px;margin-left:20px;float:left;" name="all" id="all" @click="selectall()">全选</el-button>
        <el-button type="danger" class="top_button" style="letter-spacing: 2px;float:left;" @click="deletechoose()">批量删除</el-button> -->

        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'

export default {
    data() {
        return{
            list: [],
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            show: 99,
            state: '',
            loadingShow: true,
        }
    },
    components: {
        'v-cookie': cookie
    },
    mounted() {
        this.pageChange(1);
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            this.show = 99;
            var that = this;
            let param = {'flag': 'all', 'pageIndex': pageIndex, 'pageSize': this.pageSize, 'state': this.state}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/showsystemmessage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.allsystemmessageList = res.data.allsystemmessageList;
                    that.list = that.allsystemmessageList.concat(res.data.usersystemmessageList);
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    that.$alert(res.data.msg);
                    return false;
                }
            })
        },
        showContent(index, account) {
            if(this.show != index)
            {
                this.show = index;
            }
            else
            {
                this.show = 99;
            }
            if(this.list[index].state == 0 && '*' != account)
            {
                this.updatesystemmessage(this.list[index].id);
                this.list[index].state = 1;
            }
            
        },
        checkselect(type) {
            if(type == 'all')
            {
                //全部
                this.state = ''
            }
            else if(type == '1')
            {
                //已读
                this.state = '1'
            }
            else if(type == '0')
            {
                //未读
                this.state = '0'
            }
            this.pageChange(1);
        },
        updatesystemmessage(id) {
            var that = this;
            let param = {'id': id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/updatesystemmessage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    // that.$message.success("操作成功!");
                    // that.show = 99;
                    // that.pageChange(1);
                    // that.messageRecordNum = that.messageRecordNum - 1;
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        delsystemmessage(id) {
            this.$confirm("确定删除系统消息？", '提示', {
                confirmButtonText: '确定', 
                cancelButtonText: '取消',                               
                type: 'warning'
            }).then( () => {
                var that = this;
                let param = {'id': id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + "/top/deletesystemmessage.json",
                    data: param,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'token': this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message({
                            type: 'success',
                            message: "删除系统消息成功"
                        });
                        that.show = 99;
                        that.pageChange(1);
                    }
                    else
                    {
                        that.$message({
                            type: 'error',
                            message: res.data.msg
                        });
                        return false;
                    }
                })
            }).catch( () => {
                this.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '取消'
                });
            });
        },
        //全选
        selectall() {
            var checkers = document.getElementsByName('ids');
            if(document.getElementById("all").checked == true)
            {
                document.getElementById("all").checked = false;
            }
            else
            {
                document.getElementById("all").checked = true;
            }
            if (document.getElementById("all").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        //单个选中
        choose() {
            var said = ""
            var ids = document.getElementsByName("ids")
            for(var i=0; i<ids.length; i++){
                if( ids[i].checked == true )
                {
                    if( said == "" )
                    {
                        said = ids[i].value
                    }
                    else
                    {
                        said = said + "//" + ids[i].value
                    }
                }
            }
            return said
        },
        //批量删除
        deletechoose() {
            var that = this
            if(this.choose() == "")
            {
                this.$alert("请选择删除项!")
                return false;
            }
            var that = this;
            let param = {'id': this.choose()};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/deletesystemmessage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "批量删除系统消息成功"
                    });
                    that.show = 99;
                    that.cleanchoose();
                    that.pageChange(1);
                }
                else if('9999999' == res.data.code)
                {
                    that.$message({
                        type: 'error',
                        message: '请选择删除项!'
                    });
                    return false;
                }
                else
                {
                    that.$message({
                        type: 'error',
                        message: res.data.msg
                    });
                    return false;
                }
            })
        },
        //清除所有多选框选中
        cleanchoose() {
            document.getElementById("all").checked = false
            var checkers = document.getElementsByName('ids')
            for ( var i = 0; i < checkers.length; i++)
            {
                checkers[i].checked = false
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/systemmessage/systemmessage.vue